<template>
  <div id="app" :class="'screen'+client">
    <template v-if="isCitySiteBool">
      <template v-if="client!=3">
        <template v-if="stateVal!=3">
          <top :state="stateVal" :searchKeyVal="searchKeyValue"></top>
        </template>
        <template v-else>
        </template>
        <router-view v-if="isRouterAlive" @topState="topState" @searchKeyVal="searchKeyVal" :key="key" :client="client"/>
        <transition name="fade" mode="in-out">
          <modal v-if="newVisitorBool" :state="stateVal" :client="client" @modalBool="modalBool"></modal>
        </transition>
      </template>
      <template v-else>
        <router-view v-if="isRouterAlive"  @topState="topState" class="app-content" />
        <transition name="fade" mode="in-out">
          <phone-modal v-if="newVisitorBool" :state="stateVal" :client="client" @modalBool="modalBool"></phone-modal>
        </transition>
      </template>
    </template>
    <template v-else>
      <iframe class="page-404" src="http://mappano.szscmap.com/404.html"></iframe>
    </template>
  </div>
</template>

<script>
import top from '@/components/top'
import Modal from '@/components/Modal'
import phoneModal from '@/components/Phone/Modal'
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isPC: true,
      name: '',
      stateVal: 0,
      typeId: 0,
      clientWidth: document.documentElement.clientWidth,
      newVisitorBool: false,
      searchKeyValue: '',
      isCitySiteBool:true
    }
  },
  created () {
    let that=this;
    this.isCitySite(function (bool) {
      if(bool){
        that.isCitySiteBool=true;
        window.addEventListener('resize', that.handleResize);
        that.isMobile();
        window.addEventListener('beforeunload', that.unloadHandler);
      }else {
        that.isCitySiteBool=false
      }
    });
  },
  components: {
    top: top,
    Modal: Modal,
    phoneModal: phoneModal
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    topState: function (val) { // 0:home/index.vue  1:searchPage/index.vue  2:city/index.vue 3:map/index.vue
      let that = this;
      that.stateVal = val;
      if (val === 0 || val === 2) {
        let newVisitor = that.publicJs.isNewVisitor(val);
        if (newVisitor === true) { // 如果是新访客
          // 动画弹出消息框
          that.newVisitorBool = true
        }
      }
    },
    searchKeyVal: function (val) {
      this.searchKeyValue = val
    },
    getPageTypeId: function (val) {
      this.typeId = val
    },
    modalBool: function (val) {
      this.newVisitorBool = val
    },
    handleResize (event) {
      this.clientWidth = document.documentElement.clientWidth
    },
    isMobile: function () {
      if (this.client === 3) {
      } else {
      }
    },
    unloadHandler: function () {
    },
    isCitySite:function (callback) {
      let _that=this;
      let services_user_cookie=_that.getCookie('services_user');
      let parameter = JSON.parse(_that.publicJs.decode(_that.$route.query)) || {};
      _that.httpAjax.getAjax('PanoWebService.asmx/FilterIp?cityId='+(parameter.cityId||0)+'&isPc='+_that.isPhone()+'&cookieUser='+(services_user_cookie||'')).then(function (res) {
        if (res.code === 1) {
          callback(true)
        }else {
          callback(false)
        }
      }, function (err) {
        callback(false)
      })
    },
    isPhone:function () {
      let Agents = ["android", "iphone", "symbianos", "windows phone",'ipad','ipod'],
        bool = 1;
      let ua=navigator.userAgent.toLocaleLowerCase();
      for (let key of Agents) {
        if (ua.indexOf(key) > -1) {
          bool = 0;
          break
        }
      }
      if(document.body.clientWidth<=1400||screen.availWidth<1400){
        bool = 0;
      }
      return bool
    },
    getCookie:function (name) {
      var strcookie = document.cookie;//获取cookie字符串
      var arrcookie = strcookie.split("; ");//分割
      //遍历匹配
      for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name){
          return arr[1];
        }
      }
      return "";
    }
  },
  computed: {
    key () {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date()
    },
    client () { // 0:1920  1:大于1920 2:小于1200
      let that = this;
      let c = that.clientWidth;
      if (c <= 750) {
        localStorage.setItem('isMobile', 1);
        return 3
      } else {
        localStorage.setItem('isMobile', 0);
        if (c > 1920) {
          return 1
        } else if (c < 1200 && c > 750) {
          return 2
        } else {
          return 0
        }
      }
    }
  },
  watch: {
    client: function (a, b) {
      if (a !== b) {
        this.isMobile();
        this.$router.go(0)
      }
    },
    '$route':function (a, b) {
      let that=this;
      if (that.client==3&&(a !== b)) {
        that.isCitySite(function (bool) {
          if(bool){
            that.isCitySiteBool=true;
            window.addEventListener('resize', that.handleResize);
            that.isMobile();
            window.addEventListener('beforeunload', that.unloadHandler);
          }else {
            that.isCitySiteBool=false
          }
        });
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
  @import "./common/font/font.css";
  @import "../static/css/animate.min.css";
  @import "../static/css/common.css";
  #app.screen3{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  #app.screen3>.app-content{
    width: 100%;
    height: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-animation: faseInLeft 0.5s;
    -o-animation: faseInLeft 0.5s;
    animation: faseInLeft 0.5s;
  }
  #app.screen3>.app-content.hiddenY{
    overflow-y: hidden;
  }
  .page-404{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue